<template>
  <div
    class="profile-form-skeleton"
    role="status"
    aria-busy="true"
    :aria-label="$t('portal.loadingProfile')"
  >
    <div class="profile-body">
      <section class="profile-section-skeleton">
        <span class="skeleton-bar skeleton-bar--title" />
        <div class="profile-fields-skeleton">
          <div v-for="n in 2" :key="'account-' + n" class="field-skeleton">
            <span class="skeleton-bar skeleton-bar--label" />
            <span class="skeleton-bar skeleton-bar--input" />
          </div>
        </div>
      </section>
      <div class="profile-divider-skeleton" aria-hidden="true" />
      <section class="profile-section-skeleton">
        <span class="skeleton-bar skeleton-bar--title" />
        <div class="profile-fields-skeleton">
          <div v-for="n in 2" :key="'security-' + n" class="field-skeleton">
            <span class="skeleton-bar skeleton-bar--label" />
            <span class="skeleton-bar skeleton-bar--input" />
          </div>
        </div>
      </section>
    </div>
    <footer class="profile-footer-skeleton">
      <span class="skeleton-bar skeleton-bar--footer" />
      <div class="profile-actions-skeleton">
        <span class="skeleton-bar skeleton-bar--btn" />
        <span class="skeleton-bar skeleton-bar--btn" />
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ProfileFormSkeleton'
};
</script>

<style scoped lang="scss">
.profile-form-skeleton {
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1 auto;
  min-height: 0;
}

.profile-body {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  min-height: 120px;
}

.profile-section-skeleton {
  flex: 1 1 0;
  min-width: 0;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid hsl(211, 35%, 92%);
  background: hsl(211, 55%, 98%);
}

.profile-divider-skeleton {
  width: 1px;
  flex-shrink: 0;
  margin: 0 20px;
  background: hsl(211, 35%, 88%);
}

.profile-fields-skeleton {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px 16px;
  margin-top: 12px;
}

.field-skeleton {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.profile-footer-skeleton {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid hsl(211, 35%, 92%);
}

.profile-actions-skeleton {
  display: flex;
  gap: 8px;
}

.skeleton-bar {
  display: block;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    hsl(211, 40%, 94%) 0%,
    hsl(211, 50%, 88%) 50%,
    hsl(211, 40%, 94%) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-pulse 1.4s ease-in-out infinite;

  &--title {
    width: 120px;
    height: 14px;
    border-radius: 4px;
  }

  &--label {
    width: 64px;
    height: 10px;
  }

  &--input {
    width: 100%;
    height: 34px;
    border-radius: 6px;
  }

  &--footer {
    width: 40%;
    height: 12px;
    max-width: 200px;
  }

  &--btn {
    width: 88px;
    height: 32px;
    border-radius: 6px;
  }
}

@keyframes skeleton-pulse {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

@media screen and (max-width: 900px) {
  .profile-body {
    flex-direction: column;
    gap: 14px;
  }

  .profile-divider-skeleton {
    display: none;
  }
}

@media screen and (max-width: 560px) {
  .profile-fields-skeleton {
    grid-template-columns: 1fr;
  }
}
</style>
